import Select from "react-select";
import { useTranslation } from 'react-i18next';

const FormSelect = ({ label, options, register, name, errors, onChange, colSize = 4, required = true, value = undefined,isMulti=false, isClearable=false,disabled=false }) => {
  const { t } = useTranslation();
  const colClass = `col-lg-${colSize} mb-3`;

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? 'var(--brand-red)' : provided.borderColor,
      boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(var(--brand-red-rgb), 0.25)' : provided.boxShadow,
      '&:hover': {
        borderColor: state.isFocused ? 'var(--brand-red)' : provided.borderColor,
      },
    }),
  };

  return (
    <div className={colClass}>
      <div className="form-group">
        <label className="labelDescription">
          <span className="labelText">{t(label)}</span>
          {required && <span className="labelStar text-danger fw-bold">*</span>}
        </label>
        <Select
          {...register(name)}
          options={options}
          onChange={onChange}
          value={value}
          isMulti={isMulti}
          isClearable={isClearable}
          isDisabled={disabled}
          className={`dropdown rounded-0 ${errors[name] ? "requiredSelectInput" : ""}`}
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={customStyles}
        />
        {errors[name] && (
          <div className="error-message text-danger">
            {errors[name].message}
          </div>
        )}
      </div>
    </div>
  );
};

export default FormSelect;
